<template>
  <div class="content">
      <iframe :src="srcs" class="iframe-sty" :style="height"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return { 
     srcs: '',
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
    };
  },
  created() {  
    let self = this;
    setTimeout(function(){
        self.getSrc(); 
    },500);

  },   
  watch: { 
    $route(to, from) { 
       this.getSrc(); 
    },
  }, 
  destroyed(){
    // window.removeEventListener('popstate',false);//false阻止默认事件
  },
  mounted(){    
    this.getSrc(); 
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-70+'px'; 
  
  }, 
  methods: {
    getSrc(){ 
      let self = this;
      if(self.$route.query.flowType == '00001'){
        var url = 'http://43.254.1.27:51980/reports/view/85f78fc8-0f31-4b97-996d-994574e64059?display=singlepage&parampanel=top&theme=forest&lng=zh'
      }else if(self.$route.query.flowType == '00002'){
        var url = 'http://43.254.1.27:51980/reports/view/ecd2b321-e498-4daf-b8a1-d462053cdeb3?display=singlepage&parampanel=top&theme=forest&lng=zh'
      }else{
        var url = 'http://43.254.1.27:51980/reports/view/8a2a7783-1ff4-4810-9fe6-f04fbf843880?display=singlepage&parampanel=top&theme=forest&lng=zh'
      }
      let dp = {guid:[self.$route.query.guid]}
      let wynToken = JSON.parse(localStorage.getItem("wynToken"));
      let str = JSON.stringify(dp);  
      self.srcs = url + '&token=' + wynToken + '&dp='+ encodeURIComponent(str);
      console.log(self.srcs)
    } 
  },
};
</script>
<style  scoped>
 .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  border:none;
  background:grey;
 }
</style>